@if (inited && productInformation.hintsfromEnaio) {
<p-card [header]="app.t('rungis.note')">
    <p class="m-0 hints">
        {{ productInformation.hintsfromEnaio }}
    </p>
</p-card>
}
@if (inited && !this.productInformation.requestFinished) {
<form #supplierForm="ngForm" name="form">
    <sm-tab-view #tabView [(value)]="activeTab" name="tabView">
        <sm-tab [header]="app.t('rungis.basic.title')">
            <p-fieldset [legend]="app.t('rungis.basic.set1')" class="fluid mb-5">
                <div class="flex-row mb-3 grid">
                    <label for="name"
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.basic.basicProductName')}}</label>
                    <div class="col-12 md:col-10">
                        <input pInputText [(ngModel)]="productInformation.basicProductName" class="col-4"
                            name="basicProductName" [disabled]="true">
                    </div>
                </div>
                @if (productInformation.productCategory === 'Molkerei') {
                <div class="flex-row mb-3 grid">
                    <label class="col-12 flex-row align-items-center md:col-2 md:mb-0"
                        for="fat">{{app.t('rungis.basic.basicFatContent')}}</label>
                    <div class="col-12 md:col-10">
                        <input pInputText type="number" name="basicFatContent" mode="decimal"
                            [(ngModel)]="productInformation.basicFatContent"
                            [required]="productInformation.productCategory === 'Molkerei'" />
                    </div>
                </div>
                }
                <div class="flex-row mb-3 grid">
                    <label class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.basic.basicIsBio')}} *</label>
                    <div class="flex-row align-items-center flex-wrap gap-3">
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="basicIsBio" [(ngModel)]="productInformation.basicIsBio" value="ja"
                                required />
                            <label>{{app.t('general.yes')}}</label>
                        </div>
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="basicIsBio" [(ngModel)]="productInformation.basicIsBio" value="nein"
                                required />
                            <label>{{app.t('general.no')}}</label>
                        </div>
                    </div>
                </div>
                @if (productInformation.basicIsBio === 'ja') {
                <div class="flex-row mb-3 grid">
                    <label for="bio" class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.basic.basicBioNumber')}}
                        *</label>
                    <div class="col-12 md:col-10">
                        <input pInputText name="basicBioNumber" maxlength="50" placeholder="DE-ÖKO-001"
                            [(ngModel)]="productInformation.basicBioNumber"
                            [required]="productInformation.basicIsBio === 'ja'">
                    </div>
                </div>
                }
            </p-fieldset>
            <p-fieldset [legend]="app.t('rungis.basic.set3')" class="fluid" styleClass="mt-3">
                <div class="col-12">
                    <p-checkbox [binary]="true" name="eudr" [(ngModel)]="productInformation.eudr"
                        (ngModelChange)="eudrChanged()">
                    </p-checkbox>
                    <label for="eudr" class="ml-2">{{app.t('rungis.basic.eudr')}}</label>
                </div>
                @if (productInformation.eudr) {
                <div class="col-12">
                    <p-tree #tree class="flex-item-fixed full-height" selectionMode="checkbox" [value]="eudrTree.items"
                        [(selection)]="eudrTree.selected"></p-tree>
                </div>
                }
            </p-fieldset>
            <p-fieldset [legend]="app.t('rungis.basic.set2')" class="fluid" styleClass="mt-3">
                <div class="flex-row mb-3 grid">
                    <label for="rungisName"
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.basic.basicRungisSupplierName')}}</label>
                    <div class="col-12 md:col-10">
                        <input pInputText name="basicRungisSupplierNumber"
                            [(ngModel)]="productInformation.basicRungisSupplierNumber" [disabled]="true">
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label for="supplierName"
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.basic.basicSupplierName')}} *</label>
                    <div class="col-12 md:col-10">
                        <input pInputText name="basicSupplierName" maxlength="250"
                            [(ngModel)]="productInformation.basicSupplierName" required>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.basic.basicDealerManufacturer')}}
                        *</label>
                    <div class="flex-row align-items-center flex-wrap gap-3">
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="basicDealerManufacturer"
                                [(ngModel)]="productInformation.basicDealerManufacturer" value="Händler" required />
                            <label for="supplier">{{app.t('rungis.basic.basicDealerManufacturerDealer')}}</label>
                        </div>
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="basicDealerManufacturer"
                                [(ngModel)]="productInformation.basicDealerManufacturer" value="Hersteller" required />
                            <label
                                for="manufacturer">{{app.t('rungis.basic.basicDealerManufacturerManufacturer')}}</label>
                        </div>
                    </div>
                </div>
                <div class="flex-row mb-3">
                    <label for="address">{{app.t('rungis.basic.basicManufacturerAddress')}}</label>@if
                    (productInformation.basicDealerManufacturer == 'Händler') {
                    <span> *</span>
                    }
                </div>
                <div class=" flex-col mb-3">
                    <textarea rows="5" cols="75" pTextarea name="basicManufacturerAddress"
                        [(ngModel)]="productInformation.basicManufacturerAddress"
                        [required]="productInformation.basicDealerManufacturer == 'Händler'"></textarea>
                </div>
            </p-fieldset>
            <div class="mt-3 flex-row align-items-center flex-wrap gap-3">
                <div class=" flex-col mb-3">
                    <p-button name="forwardTab1" [label]="app.t('general.continue')"
                        (onClick)="nextTab()"></p-button>
                </div>
                <div class=" flex-col mb-3">
                    <p-button name="saveFormTab1" [label]="app.t('rungis.save')" (click)="save()"></p-button>
                </div>
            </div>
        </sm-tab>
        <sm-tab [header]="app.t('rungis.details.title')">
            <p-fieldset [legend]="app.t('rungis.details.set1')" class="fluid">
                <div class="flex-row mb-3 grid">
                    <label for="detailsSupplierProductName"
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.details.detailsSupplierProductName')}}
                        *</label>
                    <div class="col-12 md:col-10">
                        <input pInputText name="detailsSupplierProductName" maxlength="250"
                            [(ngModel)]="productInformation.detailsSupplierProductName" class="col-4" required>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.details.detailsProductDescription')}}
                        *</label>
                    <div class="col-12 md:col-10">
                        <textarea name="detailsProductDescription" rows="5" cols="75" pTextarea required
                            class="col-4" [(ngModel)]="productInformation.detailsProductDescription"></textarea>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label for="supplierProductNumber"
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.details.detailsSupplierProductNumber')}}
                        *</label>
                    <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                        <input pInputText name="detailsSupplierProductNumber" maxlength="250"
                            [disabled]="productInformation.detailsSupplierProductNumberNotAvailable"
                            [(ngModel)]="productInformation.detailsSupplierProductNumber"
                            [required]="!productInformation.detailsSupplierProductNumberNotAvailable">
                        <p-checkbox name="detailsSupplierProductNumberNotAvailable"
                            [(ngModel)]="productInformation.detailsSupplierProductNumberNotAvailable" [binary]="true"
                            (ngModelChange)="productInformation.detailsSupplierProductNumberNotAvailable ? productInformation.detailsSupplierProductNumber = '' : null"></p-checkbox>
                        <label for="detailsSupplierProductNumberNotAvailable">{{app.t('rungis.notAvailable')}}</label>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label for="brand" class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.details.detailsBrand')}}
                        *</label>
                    <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                        <input pInputText name="detailsBrand" maxlength="250"
                            [disabled]="productInformation.detailsBrandNotAvailable"
                            [(ngModel)]="productInformation.detailsBrand"
                            [required]="!productInformation.detailsBrandNotAvailable">
                        <p-checkbox name="detailsBrandNotAvailable" [binary]="true"
                            [(ngModel)]="productInformation.detailsBrandNotAvailable"
                            (ngModelChange)="productInformation.detailsBrandNotAvailable ? productInformation.detailsBrand = '' : null"></p-checkbox>
                        <label for="detailsBrandNotAvailable">{{app.t('rungis.notAvailable')}}</label>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label for="specificationDate"
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.details.detailsDateOfSpecification')}}
                        *</label>
                    <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                        <p-datepicker name="detailsDateOfSpecification"
                            [(ngModel)]="productInformation.detailsDateOfSpecification"
                            [ngClass]="dateOfSpecificationInvalid() ? 'ng-invalid' : 'ng-valid'"
                            dateFormat="dd.mm.yy"></p-datepicker>
                        <p-checkbox name="detailsSpecificationChecked" [binary]="true"
                            [(ngModel)]="productInformation.detailsSpecificationChecked"
                            [required]="checkSpecificationDate()"></p-checkbox>
                        <label
                            for="detailsSpecificationChecked">{{app.t('rungis.details.detailsSpecificationChecked')}}@if
                            (checkSpecificationDate()) {
                            <span> *</span>
                            }</label>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.details.detailsGermanLabel')}}@if
                        (productInformation.uploadRequired) {
                        <span> *</span>
                        }</label>
                    <div class="flex-row align-items-center flex-wrap gap-3">
                        <p-button name="uploadLabel" [label]="app.t('rungis.details.detailsGermanLabelFileUpload')"
                            (click)="upload($event, 'germanLabel')"></p-button>
                        <label>{{ productInformation.detailsGermanLabelFile }}</label>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.details.detailsOriginalSpecification')}}@if
                        (productInformation.uploadRequired) {
                        <span> *</span>
                        }</label>
                    <div class="flex-row align-items-center flex-wrap gap-3">
                        <p-button name="uploadLabelBtn" [label]="app.t('rungis.details.uploadButton')"
                            (click)="upload($event, 'originalSpecification')"></p-button>
                        <label>{{ productInformation.detailsOriginalSpecificationFile }}</label>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.details.detailsProductImage')}}@if
                        (productInformation.uploadRequired) {
                        <span> *</span>
                        }</label>
                    <div class="flex-row align-items-center flex-wrap gap-3">
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="detailsProductImage"
                                [(ngModel)]="productInformation.detailsProductImage" value="yes" required />
                            <label>{{app.t('general.yes')}}</label>
                        </div>
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="detailsProductImage"
                                [(ngModel)]="productInformation.detailsProductImage" value="no" required />
                            <label>{{app.t('rungis.notAvailable')}}</label>
                        </div>
                    </div>
                </div>
                @if (productInformation.detailsProductImage === 'yes') {
                <div class=" flex-col mb-3">
                    <p-button name="uploadProductImage" [label]="app.t('rungis.details.detailsProductImageButton')"
                        (click)="upload($event, 'productImage')"></p-button>
                    @for (pi of productInformation.detailsProductImagesFiles; track pi; let index = $index) {
                    <div>
                        <label>{{ pi.fileName }}</label>
                    </div>
                    }
                    <div class="flex-row align-items-center flex-wrap gap-3 mt-3">
                        <p-checkbox name="imageRights" [binary]="true"
                            [(ngModel)]="productInformation.detailsProductImageRights"
                            [required]="productInformation.detailsProductImage == 'yes'"></p-checkbox>
                        <label class="ml-2">{{app.t('rungis.details.detailsProductImageRights')}}</label>
                    </div>
                </div>
                }
                <div class="flex-row mb-3 grid">
                    <label class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.details.detailsUnit')}} *</label>
                    <div class="flex-row align-items-center flex-wrap gap-3">
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="detailsUnit" [(ngModel)]="productInformation.detailsUnit" value="Stück"
                                required />
                            <label>{{app.t('rungis.unitPiece')}}</label>
                        </div>
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="detailsUnit" [(ngModel)]="productInformation.detailsUnit"
                                value="Karton" required />
                            <label>{{app.t('rungis.unitBox')}}</label>
                        </div>
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="detailsUnit" [(ngModel)]="productInformation.detailsUnit" value="kg"
                                required />
                            <label>{{app.t('rungis.unitKg')}}</label>
                        </div>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label for="price"
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.details.detailsPricePerUnit')}} *</label>
                    <div class="col-12 md:col-10">
                        <input pInputText type="number" name="detailsPricePerUnit" maxlength="50"
                            [(ngModel)]="productInformation.detailsPricePerUnit" placeholder="100" required />
                        <span class="ml-2">€</span>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label for="bestBeforeDays"
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.details.detailsBestBeforeDays')}} *</label>
                    <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                        <input pInputText name="detailsBestBeforeDays" type="number"
                            [disabled]="productInformation.bestBeforeNotRequired"
                            [(ngModel)]="productInformation.detailsBestBeforeDays"
                            (ngModelChange)="calculateGuaranteedBestBefore()"
                            [required]="!productInformation.bestBeforeNotRequired" />
                        <p-checkbox name="bestBeforeNotRequired" [(ngModel)]="productInformation.bestBeforeNotRequired"
                            [binary]="true"
                            (ngModelChange)="productInformation.bestBeforeNotRequired ? productInformation.detailsBestBeforeDays = 0 : null"></p-checkbox>
                        <label for="bestBeforeDaysNA">{{app.t('rungis.notNeeded')}}</label>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.details.detailsGuaranteedBestBefore')}}
                        *</label>
                    <div class="col-12 md:col-10">
                        <input pInputText name="detailsGuaranteedBestBefore" maxlength="50" type="number"
                            [(ngModel)]="productInformation.detailsGuaranteedBestBefore" required />
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label for="daysUntilDelivery"
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.details.detailsDaysUntilDelivery')}}
                        *</label>
                    <div class="col-12 md:col-10">
                        <input pInputText name="detailsDaysUntilDelivery" maxlength="50" type="number"
                            [(ngModel)]="productInformation.detailsDaysUntilDelivery" required />
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label for="minOrderQuantity"
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.details.detailsMinOrderQuantity')}}
                        *</label>
                    <div class="col-12 md:col-10">
                        <input pInputText name="detailsMinOrderQuantity" maxlength="50" type="number"
                            [(ngModel)]="productInformation.detailsMinOrderQuantity" required />
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label for="detailsCustomerFeeNumber"
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.details.detailsCustomsFeeNumber')}}
                        *</label>
                    <div class="col-12 md:col-10">
                        <div>
                            <input pInputText name="detailsCustomsFeeNumber" maxlength="50"
                                [ngClass]="customsNumberValid ? 'ng-valid' : 'ng-invalid'"
                                [(ngModel)]="productInformation.detailsCustomsFeeNumber" (blur)="checkCustomsNumber()"
                                required />
                        </div>
                        <div class="mt-2">
                            <label class="bold">{{ productInformation.customsNumberDescription }}</label>
                        </div>
                    </div>
                </div>
            </p-fieldset>
            <div class="flex-row align-items-center flex-wrap gap-3 mt-3">
                <div class=" flex-col mb-3">
                    <p-button name="backTab2" [label]="app.t('general.back')"
                        (onClick)="previousTab()"></p-button>
                </div>
                <div class=" flex-col mb-3">
                    <p-button name="forwardTab2" [label]="app.t('general.continue')"
                        (onClick)="nextTab()"></p-button>
                </div>
                <div class=" flex-col mb-3">
                    <p-button name="saveTab2" [label]="app.t('rungis.save')" (click)="save()"></p-button>
                </div>
            </div>
        </sm-tab>
        <sm-tab [header]="app.t('rungis.generalOrigin.title')">
            <div class="grid">
                <p-fieldset [legend]="app.t('rungis.generalOrigin.title')" class="fluid col-6">
                    <div class="flex-row mb-3 grid">
                        <label for="name"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.generalOrigin.HerkunftslandAlg')}}
                            *</label>
                        <div class="col-12 md:col-10">
                            <input pInputText class="col-4" name="HerkunftslandAlg" maxlength="50"
                                [(ngModel)]="productInformation.herkunftslandAlg" required />
                        </div>
                    </div>
                    <div class=" flex-col mb-3">
                        <label
                            for="ZusaetzlicheArtikelInfos">{{app.t('rungis.generalOrigin.ZusaetzlicheArtikelInfos')}}</label>
                    </div>
                    <div class=" flex-col mb-3">
                        <textarea rows="5" cols="75" pTextarea name="ZusaetzlicheArtikelInfos"
                            [(ngModel)]="productInformation.zusaetzlicheArtikelInfos"></textarea>
                    </div>
                    <div class=" flex-col mb-3">
                        <label for="Sensorik">{{app.t('rungis.generalOrigin.Sensorik')}}</label>
                    </div>
                    <div class=" flex-col mb-3">
                        <textarea rows="5" cols="75" pTextarea name="Sensorik"
                            [(ngModel)]="productInformation.sensorik"></textarea>
                    </div>
                    <div class=" flex-col mb-3">
                        <label for="Verwendungszweck">{{app.t('rungis.generalOrigin.Verwendungszweck')}}</label>
                    </div>
                    <div class=" flex-col mb-3">
                        <textarea rows="5" cols="75" pTextarea name="Verwendungszweck"
                            [(ngModel)]="productInformation.verwendungszweck"></textarea>
                    </div>
                    <div class=" flex-col mb-3">
                        <label for="Schaerfegrad">{{app.t('rungis.generalOrigin.Schaerfegrad')}}</label>
                    </div>
                    <div class=" flex-col mb-3">
                        <textarea rows="5" cols="75" pTextarea name="Schaerfegrad"
                            [(ngModel)]="productInformation.schaerfegrad"></textarea>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="SchaerfegradIcon"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.generalOrigin.SchaerfegradIcon')}}</label>
                        <div class="col-12 md:col-10">
                            <p-select class="ml-2 col-4" name="schaerfegradIcon"
                                [(ngModel)]="productInformation.schaerfegradIcon"
                                [options]="[{label: 1, value: '1'}, {label: 2, value: '2'}, {label: 3, value: '3'}, {label: 4, value: '4'}, {label: 5, value: '5'} ]"></p-select>
                        </div>
                    </div>
                </p-fieldset>
                <p-fieldset [legend]="app.t('rungis.generalOrigin.title')" class="fluid col-6">
                    <div class="flex-row mb-3 grid">
                        <label for="Klasse"
                            class="col-12 flex-row align-items-center md:col-4 md:mb-0">{{app.t('rungis.generalOrigin.Klasse')}}</label>
                        <div class="col-12 md:col-8">
                            <input pInputText class="col-4" name="Klasse" maxlength="50"
                                [(ngModel)]="productInformation.klasse" />
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="Kaliber"
                            class="col-12 flex-row align-items-center md:col-4 md:mb-0">{{app.t('rungis.generalOrigin.Kaliber')}}</label>
                        <div class="col-12 md:col-8">
                            <input pInputText class="col-4" name="Kaliber" maxlength="50"
                                [(ngModel)]="productInformation.kaliber" />
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid mt-8">
                        <label for="Raeucherart"
                            class="col-12 flex-row align-items-center md:col-4 md:mb-0">{{app.t('rungis.generalOrigin.Raeucherart')}}</label>
                        <div class="col-12 md:col-8">
                            <p-select class="ml-2 col-4" name="Raeucherart" [(ngModel)]="productInformation.raeucherart"
                                [options]="[{label: app.t('rungis.generalOrigin.RaeucherartItem1'), value: 'warm'}, {label: app.t('rungis.generalOrigin.RaeucherartItem2'), value: 'kalt'} ]"></p-select>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="Holzart"
                            class="col-12 flex-row align-items-center md:col-4 md:mb-0">{{app.t('rungis.generalOrigin.Holzart')}}</label>
                        <div class="col-12 md:col-8">
                            <input pInputText class="col-4" name="Holzart" maxlength="50"
                                [(ngModel)]="productInformation.holzart" />
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid mt-8">
                        <label>{{app.t('rungis.generalOrigin.Kaviar')}}</label>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="Salzgehalt"
                            class="col-12 flex-row align-items-center md:col-4 md:mb-0">{{app.t('rungis.generalOrigin.Salzgehalt')}}</label>
                        <div class="col-12 md:col-8">
                            <input pInputText class="col-4" name="Salzgehalt" maxlength="50"
                                [(ngModel)]="productInformation.salzgehalt" />
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="KorngroesseDesKaviars"
                            class="col-12 flex-row align-items-center md:col-4 md:mb-0">{{app.t('rungis.generalOrigin.KorngroesseDesKaviars')}}</label>
                        <div class="col-12 md:col-8">
                            <input pInputText class="col-4" name="KorngroesseDesKaviars" maxlength="50"
                                [(ngModel)]="productInformation.korngroesseDesKaviars" />
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid mt-8">
                        <label for="Verarbeitungstemperatur"
                            class="col-12 flex-row align-items-center md:col-4 md:mb-0">{{app.t('rungis.generalOrigin.Verarbeitungstemperatur')}}</label>
                        <div class="col-12 md:col-8">
                            <input pInputText class="col-4" name="Verarbeitungstemperatur" maxlength="50"
                                [(ngModel)]="productInformation.verarbeitungstemperatur" />
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="WasserFettloeslich"
                            class="col-12 flex-row align-items-center md:col-4 md:mb-0">{{app.t('rungis.generalOrigin.WasserFettloeslich')}}</label>
                        <div class="col-12 md:col-8">
                            <p-select class="ml-2 col-4" name="WasserFettloeslich"
                                [(ngModel)]="productInformation.wasserFettloeslich"
                                [options]="[{label: app.t('rungis.generalOrigin.WasserFettloeslichItem1'), value: 'Wasserlöslich'}, {label: app.t('rungis.generalOrigin.WasserFettloeslichItem2'), value: 'Fettlöslich' } ]"></p-select>
                        </div>
                    </div>
                </p-fieldset>
            </div>
            <div class="flex-row align-items-center flex-wrap gap-3 mt-3">
                <div class=" flex-col mb-3">
                    <p-button name="backTab2" [label]="app.t('general.back')"
                        (onClick)="previousTab()"></p-button>
                </div>
                <div class=" flex-col mb-3">
                    <p-button name="forwardTab2" [label]="app.t('general.continue')"
                        (onClick)="nextTab()"></p-button>
                </div>
                <div class=" flex-col mb-3">
                    <p-button name="saveTab2" [label]="app.t('rungis.save')" (click)="save()"></p-button>
                </div>
            </div>
        </sm-tab>
        @if (productInformation.productCategory == 'Fleisch') {
        <sm-tab [header]="app.t('rungis.meat.title')">
            <div class="grid">
                <p-fieldset [legend]="app.t('rungis.meat.set0')" class="col-12 fluid">
                    <div class="col-6 flex-row mb-3 grid">
                        <label for="haltungsform"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.meat.Haltungsform')}}</label>
                        <div class="col-12 md:col-10">
                            <p-select class="ml-2 col-4" name="haltungsform"
                                [(ngModel)]="productInformation.haltungsform"
                                [options]="[{label: app.t('rungis.meat.FleischMuttertierhaltungItem1'), value: 'Stallhaltung'}, {label: app.t('rungis.meat.FleischMuttertierhaltungItem2'), value: 'Stall+Platz'}, {label: app.t('rungis.meat.FleischMuttertierhaltungItem3'), value: 'Frischluftstall'}, {label: app.t('rungis.meat.FleischMuttertierhaltungItem4'), value: 'Auslauf/Weide'}, {label: app.t('rungis.meat.FleischMuttertierhaltungItem5'), value: 'Bio'}]"
                                [required]=true></p-select>
                        </div>
                    </div>
                </p-fieldset>
                <p-fieldset [legend]="app.t('rungis.meat.set1')" class="col-6 fluid">
                    <div class="flex-row mb-3 grid">
                        <label for="name"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.meat.FleischRasseZucht')}}</label>
                        <div class="col-12 md:col-10">
                            <input pInputText name="FleischRasseZucht" maxlength="50"
                                [(ngModel)]="productInformation.fleischRasseZucht" />
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="name"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.meat.beefBornIn')}}</label>
                        <div class="col-12 md:col-10">
                            <input pInputText name="beefBornIn" maxlength="50"
                                [(ngModel)]="productInformation.beefBornIn" />
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="name"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.meat.beefGrownIn')}}</label>
                        <div class="col-12 md:col-10">
                            <input pInputText name="beefGrownIn" maxlength="50"
                                [(ngModel)]="productInformation.beefGrownIn" />
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="name"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.meat.beefButcheredIn')}}</label>
                        <div class="col-12 md:col-10">
                            <input pInputText name="beefButcheredIn" maxlength="50"
                                [(ngModel)]="productInformation.beefButcheredIn" />
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="name"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.meat.beefCutIn')}}</label>
                        <div class="col-12 md:col-10">
                            <input pInputText name="beefCutIn" maxlength="50"
                                [(ngModel)]="productInformation.beefCutIn" />
                        </div>
                    </div>
                </p-fieldset>
                <p-fieldset [legend]="app.t('rungis.meat.set3')" class="col-6 fluid">
                    <div class="flex-row mb-3 grid">
                        <label for="fleischMuttertierhaltung"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.meat.FleischMuttertierhaltung')}}</label>
                        <div class="col-12 md:col-10">
                            <p-select class="ml-2 col-4" name="fleischMuttertierhaltung"
                                [(ngModel)]="productInformation.fleischMuttertierhaltung"
                                [options]="[{label: app.t('rungis.meat.FleischMuttertierhaltungItem1'), value: 'Stallhaltung'}, {label: app.t('rungis.meat.FleischMuttertierhaltungItem2'), value: 'Stall+Platz'}, {label: app.t('rungis.meat.FleischMuttertierhaltungItem3'), value: 'Frischluftstall'}, {label: app.t('rungis.meat.FleischMuttertierhaltungItem4'), value: 'Auslauf/Weide'}, {label: app.t('rungis.meat.FleischMuttertierhaltungItem5'), value: 'Bio'}]"></p-select>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="name"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.meat.FleischFuetterung')}}</label>
                        <div class="col-12 md:col-10">
                            <input pInputText name="FleischFuetterung" maxlength="50"
                                [(ngModel)]="productInformation.fleischFuetterung" />
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="fleischGeschlecht"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.meat.FleischGeschlecht')}}</label>
                        <div class="col-12 md:col-10">
                            <p-select class="ml-2 col-4" name="fleischGeschlecht"
                                [(ngModel)]="productInformation.fleischGeschlecht"
                                [options]="[{label: app.t('rungis.meat.FleischGeschlechtItem1'), value: 'männlich'}, {label: app.t('rungis.meat.FleischGeschlechtItem2'), value: 'weiblich'}]"></p-select>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="name"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.meat.FleischSchlachtalter')}}</label>
                        <div class="col-12 md:col-10">
                            <input pInputText name="FleischSchlachtalter" maxlength="50"
                                [(ngModel)]="productInformation.fleischSchlachtalter" />
                        </div>
                    </div>
                </p-fieldset>
            </div>
            <p-fieldset [legend]="app.t('rungis.meat.set2')" class="fluid">
                <div class="flex-row mb-3 grid">
                    <label for="name"
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.meat.FleischZuchtRasse')}}</label>
                    <div class="col-12 md:col-10">
                        <input pInputText name="FleischZuchtRasse" maxlength="50"
                            [(ngModel)]="productInformation.fleischZuchtRasse" />
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label for="name" class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.meat.meatGrownIn')}}</label>
                    <div class="col-12 md:col-10">
                        <input pInputText name="meatGrownIn" maxlength="50"
                            [(ngModel)]="productInformation.meatGrownIn" />
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label for="name"
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.meat.beefButcheredIn')}}</label>
                    <div class="col-12 md:col-10">
                        <input pInputText name="meatButcheredIn" maxlength="50"
                            [(ngModel)]="productInformation.meatButcheredIn" />
                    </div>
                </div>
            </p-fieldset>
            <div class="grid mt-3">
                <p-fieldset [legend]="app.t('rungis.meat.set4')" class="col-6 fluid">
                    <div class="flex-row mb-3 grid">
                        <label for="name"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.meat.FleischPattieDurchmesser')}}</label>
                        <div class="col-12 md:col-10">
                            <input pInputText name="FleischPattieDurchmesser" maxlength="50"
                                [(ngModel)]="productInformation.fleischPattieDurchmesser" />
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="fleischWolfgrad"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.meat.FleischWolfgrad')}}</label>
                        <div class="col-12 md:col-10">
                            <p-select class="ml-2 col-4" name="fleischWolfgrad"
                                [(ngModel)]="productInformation.fleischWolfgrad"
                                [options]="[{label: app.t('rungis.meat.FleischWolfgradItem1'), value: 'fein gewolft'}, {label: app.t('rungis.meat.FleischWolfgradItem2'), value: 'grob gewolft'}]"></p-select>
                        </div>
                    </div>
                </p-fieldset>
                <p-fieldset [legend]="app.t('rungis.meat.set5')" class="col-6 fluid">
                    <div class="flex-row mb-3 grid">
                        <label for="fleischMitKetten"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.meat.FleischMitKetten')}}</label>
                        <div class="col-12 md:col-10">
                            <p-select class="ml-2 col-4" name="fleischMitKetten"
                                [(ngModel)]="productInformation.fleischMitKetten"
                                [options]="[{label: app.t('rungis.meat.FleischMitKettenItem1'), value: 'Ohne Kette'}, {label: app.t('rungis.meat.FleischMitKettenItem2'), value: 'Mit Kette'}]"></p-select>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="fleischMitKnochen"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.meat.FleischMitKnochen')}}</label>
                        <div class="col-12 md:col-10">
                            <p-select class="ml-2 col-4" name="fleischMitKnochen"
                                [(ngModel)]="productInformation.fleischMitKnochen"
                                [options]="[{label: app.t('rungis.meat.FleischMitKnochenItem1'), value: 'Ohne Knochen'}, {label: app.t('rungis.meat.FleischMitKnochenItem2'), value: 'Mit Knochen'}]"></p-select>
                        </div>
                    </div>
                </p-fieldset>
            </div>
            <div class="mt-3 flex-row align-items-center flex-wrap gap-3">
                <div class=" flex-col mb-3">
                    <p-button name="backTab3" [label]="app.t('general.back')"
                        (onClick)="previousTab()"></p-button>
                </div>
                <div class=" flex-col mb-3">
                    <p-button name="forwardTab3" [label]="app.t('general.continue')"
                        (onClick)="nextTab()"></p-button>
                </div>
                <div class=" flex-col mb-3">
                    <p-button name="saveTab3" [label]="app.t('rungis.save')" (click)="save()"></p-button>
                </div>
            </div>
        </sm-tab>
        }
        @if (productInformation.productCategory == 'Fisch') {
        <sm-tab [header]="app.t('rungis.fish.title')">
            <div class="grid">
                <p-fieldset [legend]="app.t('rungis.fish.set1')" class="fluid col-6">
                    <div class="flex-row mb-3 grid">
                        <label class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.fish.fishIsASC')}} *</label>
                        <div class="flex-row align-items-center flex-wrap gap-3">
                            <div class="flex-row align-items-center gap-2 ">
                                <p-radioButton name="fishIsASC" [(ngModel)]="productInformation.fishIsASC" value="ja"
                                    [class.ng-invalid]="productInformation.fishIsMSC == 'ja' && productInformation.fishIsASC == 'ja'"
                                    required />
                                <label>{{app.t('general.yes')}}</label>
                            </div>
                            <div class="flex-row align-items-center gap-2 ">
                                <p-radioButton name="fishIsASC" [(ngModel)]="productInformation.fishIsASC" value="nein"
                                    required />
                                <label>{{app.t('general.no')}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.fish.fishIsMSC')}} *</label>
                        <div class="flex-row align-items-center flex-wrap gap-3">
                            <div class="flex-row align-items-center gap-2 ">
                                <p-radioButton name="fishIsMSC" [(ngModel)]="productInformation.fishIsMSC" value="ja"
                                    [class.ng-invalid]="productInformation.fishIsMSC == 'ja' && productInformation.fishIsASC == 'ja'"
                                    required />
                                <label>{{app.t('general.yes')}}</label>
                            </div>
                            <div class="flex-row align-items-center gap-2 ">
                                <p-radioButton name="fishIsMSC" [(ngModel)]="productInformation.fishIsMSC" value="nein"
                                    required />
                                <label>{{app.t('general.no')}}</label>
                            </div>
                        </div>
                    </div>
                    @if (productInformation.fishIsASC === 'ja' || productInformation.fishIsMSC === 'ja') {
                    <div class="flex-row mb-3 grid">
                        <label for="asc" class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.fish.fishAscMscNumber')}}
                            *</label>
                        <div class="col-12 md:col-10">
                            <input pInputText name="fishAscMscNumber" maxlength="50"
                                [(ngModel)]="productInformation.fishAscMscNumber"
                                [required]="productInformation.fishIsASC === 'ja' || productInformation.fishIsMSC === 'ja'">
                        </div>
                    </div>
                    }
                    <div class="flex-row mb-3 grid">
                    </div>
                    <div class="flex-row mb-3 grid">
                        <div class="flex-row align-items-center flex-wrap gap-3">
                            <div class="flex-row align-items-center gap-2 ">
                                <p-radioButton name="fishWater" [(ngModel)]="productInformation.fishWater" value="fresh"
                                    required />
                                <label>{{app.t('rungis.fish.fishWaterFresh')}}</label>
                            </div>
                            <div class="flex-row align-items-center gap-2 ">
                                <p-radioButton name="fishWater" [(ngModel)]="productInformation.fishWater" value="salt"
                                    required />
                                <label>{{app.t('rungis.fish.fishWaterSalt')}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <div class="col-12 flex-row align-items-center md:col-2 md:mb-0">
                            <p-checkbox [binary]="true" name="fishAquaculture"
                                [(ngModel)]="productInformation.fishAquaculture" (ngModelChange)="aquacultureChanged()"
                                [disabled]="productInformation.fishWildCaught || productInformation.fishInlandFisheries"></p-checkbox>
                            <label for="eanPieceNA" class="ml-2">{{app.t('rungis.fish.fishAquaculture')}}</label>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="eanPieceNA"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.fish.fishOriginAC')}}</label>
                        <div class="col-12 md:col-10">
                            <input pInputText class="ml-2" name="fishOriginAC"
                                [(ngModel)]="productInformation.fishOriginAC"
                                [disabled]="!productInformation.fishAquaculture"
                                [required]="productInformation.fishAquaculture">
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <div class="col-12 flex-row align-items-center md:col-2 md:mb-0">
                            <p-checkbox [binary]="true" name="fishWildCaught"
                                [(ngModel)]="productInformation.fishWildCaught" (ngModelChange)="wildCaughtChanged()"
                                [disabled]="productInformation.fishAquaculture|| productInformation.fishInlandFisheries"></p-checkbox>
                            <label for="eanPieceNA" class="ml-2">{{app.t('rungis.fish.fishWildCaught')}}</label>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="eanPieceNA"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.fish.fishCatchmentArea')}}{{productInformation.fishWildCaught
                            ? ' *' : ''}}</label>
                        <div class="col-12 md:col-10">
                            <input pInputText class="ml-2" name="fishCatchmentArea" maxlength="50"
                                [(ngModel)]="productInformation.fishCatchmentArea"
                                [required]="productInformation.fishWildCaught"
                                [disabled]="!productInformation.fishWildCaught">
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="eanPieceNA"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.fish.fishSubCatchmentArea')}}</label>
                        <div class="col-12 md:col-10">
                            <input pInputText class="ml-2" name="fishSubCatchmentArea" maxlength="50"
                                [(ngModel)]="productInformation.fishSubCatchmentArea"
                                [disabled]="!productInformation.fishWildCaught || (productInformation.fishCatchmentArea != '27' && productInformation.fishCatchmentArea != '37')"
                                [required]="productInformation.fishWildCaught">
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="eanPieceNA"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.fish.fishWildGearCategory')}}</label>
                        <div class="col-12 md:col-10">
                            <input pInputText class="ml-2" name="fishWildGearCategory" maxlength="50"
                                [(ngModel)]="productInformation.fishWildGearCategory"
                                [disabled]="!productInformation.fishWildCaught"
                                [required]="productInformation.fishWildCaught">
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <div class="col-12 flex-row align-items-center md:col-2 md:mb-0">
                            <p-checkbox [binary]="true" name="fishInlandFisheries"
                                [(ngModel)]="productInformation.fishInlandFisheries"
                                (ngModelChange)="inlandFisheriesChanged()"
                                [disabled]="productInformation.fishWildCaught || productInformation.fishAquaculture"></p-checkbox>
                            <label for="eanPieceNA" class="ml-2">{{app.t('rungis.fish.fishInlandFisheries')}}</label>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="eanPieceNA"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.fish.fishInlandOrigin')}}</label>
                        <div class="col-12 md:col-10">
                            <input pInputText class="ml-2" name="fishInlandOrigin" maxlength="50"
                                [(ngModel)]="productInformation.fishInlandOrigin"
                                [disabled]="!productInformation.fishInlandFisheries"
                                [required]="productInformation.fishInlandFisheries">
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="eanPieceNA"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.fish.fishInlandGearCategory')}}</label>
                        <div class="col-12 md:col-10">
                            <input pInputText class="ml-2" name="fishInlandGearCategory" maxlength="50"
                                [(ngModel)]="productInformation.fishInlandGearCategory"
                                [disabled]="!productInformation.fishInlandFisheries"
                                [required]="productInformation.fishInlandFisheries">
                        </div>
                    </div>
                </p-fieldset>
                <p-fieldset [legend]="app.t('rungis.fish.set2')" class="fluid col-6">
                    <div class="flex-row mb-3 grid">
                        <label for="fischAusgenommen"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.fish.fischAusgenommen')}}</label>
                        <div class="col-12 md:col-10">
                            <p-select class="ml-2 col-4" name="fischAusgenommen"
                                [(ngModel)]="productInformation.fischAusgenommen"
                                [options]="[{label: app.t('rungis.fish.fischAusgenommenItem1'), value: 'rund'}, {label: app.t('rungis.fish.fischAusgenommenItem2'), value: 'ausgenommen'}]"></p-select>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="fischMitHaut"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.fish.fischMitHaut')}}</label>
                        <div class="col-12 md:col-10">
                            <p-select class="ml-2 col-4" name="fischMitHaut"
                                [(ngModel)]="productInformation.fischMitHaut"
                                [options]="[{label: app.t('rungis.fish.fischMitHautItem1'), value: 'Mit Haut'}, {label: app.t('rungis.fish.fischMitHautItem2'), value: 'Ohne Haut'}]"></p-select>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.fish.fischGeschuppt')}}</label>
                        <div class="flex-row align-items-center flex-wrap gap-3">
                            <div class="flex-row align-items-center gap-2 ">
                                <p-radioButton name="fischGeschuppt" [(ngModel)]="productInformation.fischGeschuppt"
                                    value=true />
                                <label>{{app.t('general.yes')}}</label>
                            </div>
                            <div class="flex-row align-items-center gap-2 ">
                                <p-radioButton name="fischGeschuppt" [(ngModel)]="productInformation.fischGeschuppt"
                                    value=false required />
                                <label>{{app.t('general.no')}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="fischMitKopf"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.fish.fischMitKopf')}}</label>
                        <div class="col-12 md:col-10">
                            <p-select class="ml-2 col-4" name="fischMitKopf"
                                [(ngModel)]="productInformation.fischMitKopf"
                                [options]="[{label: app.t('rungis.fish.fischMitKopfItem1'), value: 'Mit Kopf'}, {label: app.t('rungis.fish.fischMitKopfItem2'), value: 'Ohne Kopf'}]"></p-select>
                        </div>
                    </div>
                </p-fieldset>
            </div>
            <div class="flex-row align-items-center flex-wrap gap-3 mt-3">
                <div class=" flex-col mb-3">
                    <p-button name="backTab4" [label]="app.t('general.back')"
                        (onClick)="previousTab()"></p-button>
                </div>
                <div class=" flex-col mb-3">
                    <p-button name="forwardTab4" [label]="app.t('general.continue')"
                        (onClick)="nextTab()"></p-button>
                </div>
                <div class=" flex-col mb-3">
                    <p-button name="saveTab4" [label]="app.t('rungis.save')" (click)="save()"></p-button>
                </div>
            </div>
        </sm-tab>
        }
        @if (productInformation.productCategory == 'Feinkost') {
        <sm-tab [header]="app.t('rungis.deli.title')">
            <p-fieldset [legend]="app.t('rungis.deli.set1')" class="fluid mt-3">
                <div class="flex-row mb-3 grid">
                    <label for="FeinkostKaeseArt"
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.deli.FeinkostKaeseArt')}}</label>
                    <div class="col-12 md:col-10">
                        <p-select class="ml-2 col-2" name="FeinkostKaeseArt"
                            [(ngModel)]="productInformation.feinkostKaeseArt"
                            [options]="[{label: 'Rohmilchkäse', value: app.t('rungis.deli.FeinkostKaeseArtItem1')}, {label: 'pasteurisierte Milch', value: app.t('rungis.deli.FeinkostKaeseArtItem2')} ]"></p-select>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label for="FeinkostReifegrad"
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.deli.FeinkostReifegrad')}}</label>
                    <div class="col-12 md:col-10">
                        <input pInputText class="col-2 mr-2" name="FeinkostReifegrad" maxlength="50"
                            [(ngModel)]="productInformation.feinkostReifegrad" />
                        <p-select class="ml-2 col-2" name="FeinkostReifegradEinheit"
                            [(ngModel)]="productInformation.feinkostReifegradEinheit"
                            [options]="[{label: 'Tage', value: app.t('rungis.deli.FeinkostReifegradEinheitItem1')}, {label: 'Wochen', value: app.t('rungis.deli.FeinkostReifegradEinheitItem2')}, {label: 'Monate', value: app.t('rungis.deli.FeinkostReifegradEinheitItem3')} ]"></p-select>
                    </div>
                </div>
            </p-fieldset>
            <p-fieldset [legend]="app.t('rungis.deli.set2')" class="fluid mt-3">
                <div class="flex-row mb-3 grid">
                    <label for="FeinkostGepresst"
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.deli.FeinkostGepresst')}}</label>
                    <div class="col-12 md:col-10">
                        <p-select class="ml-2 col-2" name="FeinkostGepresst"
                            [(ngModel)]="productInformation.feinkostGepresst"
                            [options]="[{label: 'Kalt', value: app.t('rungis.deli.FeinkostGepresstItem1')}, {label: 'Warm', value: app.t('rungis.deli.FeinkostGepresstItem2')} ]"></p-select>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label for="name"
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.deli.FeinkostFiltration')}}</label>
                    <div class="col-12 md:col-10">
                        <input pInputText class="col-2" name="FeinkostFiltration" maxlength="50"
                            [(ngModel)]="productInformation.feinkostFiltration" />
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label for="FeinkostReifung"
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.deli.FeinkostReifung')}}</label>
                    <div class="col-12 md:col-10">
                        <input pInputText class="col-2 mr-2" name="FeinkostReifung" maxlength="50"
                            [(ngModel)]="productInformation.feinkostReifung" />
                        <p-select class="ml-2 col-2" name="FeinkostReifungEinheit"
                            [(ngModel)]="productInformation.feinkostReifungEinheit"
                            [options]="[{label: 'Tage', value: app.t('rungis.deli.FeinkostReifungEinheitItem1')}, {label: 'Wochen', value: app.t('rungis.deli.FeinkostReifungEinheitItem2')}, {label: 'Monate', value: app.t('rungis.deli.FeinkostReifungEinheitItem3')} ]"></p-select>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label for="name"
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.deli.FeinkostRebsorte')}}</label>
                    <div class="col-12 md:col-10">
                        <input pInputText class="col-2" name="FeinkostRebsorte" maxlength="50"
                            [(ngModel)]="productInformation.feinkostRebsorte" />
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label for="name"
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.deli.FeinkostSaeuregehalt')}}</label>
                    <div class="col-12 md:col-10">
                        <input pInputText class="col-2" name="FeinkostSaeuregehalt" maxlength="50"
                            [(ngModel)]="productInformation.feinkostSaeuregehalt" />
                    </div>
                </div>
            </p-fieldset>
            <p-fieldset [legend]="app.t('rungis.deli.set3')" class="fluid col-6 mt-3">
                <div class="flex-row mb-3 grid">
                    <label for="name"
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.deli.FeinkostSortimentinhalt')}}</label>
                    <div class="col-12 md:col-10">
                        <input pInputText class="col-2" name="FeinkostSortimentinhalt" maxlength="50"
                            [(ngModel)]="productInformation.feinkostSortimentinhalt" />
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label for="FeinkostEinheitGroesse"
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.deli.FeinkostEinheitGroesse')}}</label>
                    <div class="col-12 md:col-10">
                        <p-select class="ml-2 col-2" name="FeinkostEinheitGroesse"
                            [(ngModel)]="productInformation.feinkostEinheitGroesse"
                            [options]="[{label: app.t('rungis.deli.FeinkostEinheitGroesseItem1'), value: 'Größe'}, {label: app.t('rungis.deli.FeinkostEinheitGroesseItem2'), value: 'Länge'}, {label: app.t('rungis.deli.FeinkostEinheitGroesseItem3'), value: 'Durchmesser'}]"></p-select>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label for="name"
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.deli.FeinkostGroesse')}}</label>
                    <div class="col-12 md:col-10">
                        <input pInputText class="col-2" name="FeinkostGroesse" maxlength="50"
                            [(ngModel)]="productInformation.feinkostGroesse" />
                        <span class="ml-2">{{app.t('rungis.deli.FeinkostGroesseUnit')}}</span>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.deli.FeinkostSauerteig')}}</label>
                    <div class="flex-row align-items-center flex-wrap gap-3">
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="FeinkostSauerteig" [(ngModel)]="productInformation.feinkostSauerteig"
                                value="Ja" />
                            <label for="FeinkostSauerteigYes">{{app.t('general.yes')}}</label>
                        </div>
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="FeinkostSauerteig" [(ngModel)]="productInformation.feinkostSauerteig"
                                value="Nein" />
                            <label for="FeinkostSauerteigNo">{{app.t('general.no')}}</label>
                        </div>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label for="name"
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.deli.FeinkostMehlsorten')}}</label>
                    <div class="col-12 md:col-10">
                        <input pInputText class="col-2" name="FeinkostMehlsorten" maxlength="50"
                            [(ngModel)]="productInformation.feinkostMehlsorten" />
                    </div>
                </div>
                <div class=" flex-col mb-3">
                    <label for="FeinkostGeschmack">{{app.t('rungis.deli.FeinkostGeschmack')}}</label>
                </div>
                <div class=" flex-col mb-3">
                    <textarea rows="5" cols="75" pTextarea name="FeinkostGeschmack"
                        [(ngModel)]="productInformation.feinkostGeschmack"></textarea>
                </div>
            </p-fieldset>
            <div class="flex-row align-items-center flex-wrap gap-3 mt-3">
                <div class=" flex-col mb-3">
                    <p-button name="backTab4" [label]="app.t('general.back')"
                        (onClick)="previousTab()"></p-button>
                </div>
                <div class=" flex-col mb-3">
                    <p-button name="forwardTab4" [label]="app.t('general.continue')"
                        (onClick)="nextTab()"></p-button>
                </div>
                <div class=" flex-col mb-3">
                    <p-button name="saveTab4" [label]="app.t('rungis.save')" (click)="save()"></p-button>
                </div>
            </div>
        </sm-tab>
        }
        <sm-tab [header]="app.t('rungis.logisticsAndPackaging.title')">
            <p-fieldset [legend]="app.t('rungis.logisticsAndPackaging.set1')" class="fluid">
                <div class="flex-row mb-3 grid">
                    <label
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.logisticsAndPackaging.logisticsEANPiece')}}</label>
                    <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                        <label for="eanPiece" class="col-1 mb-1 md:col-1 md:mb-0">{{app.t('rungis.unitPiece')}}</label>
                        <input pInputText name="logisticsEANPiece" maxlength="13"
                            [class.ng-invalid]="!productInformation.logisticsEANPieceNotAvailable && !isEanValid(productInformation.logisticsEANPiece)"
                            [disabled]="productInformation.logisticsEANPieceNotAvailable"
                            [(ngModel)]="productInformation.logisticsEANPiece">
                        <p-checkbox id="eanPieceNA" [binary]="true" name="logisticsEANPieceNotAvailable"
                            [(ngModel)]="productInformation.logisticsEANPieceNotAvailable"></p-checkbox>
                        <label for="eanPieceNA">{{app.t('rungis.notAvailable')}}</label>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label class="col-12 flex-row align-items-center md:col-2 md:mb-0"></label>
                    <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                        <label for="eanBox" class="col-1 mb-1 md:col-1 md:mb-0">{{app.t('rungis.unitBox')}}</label>
                        <input pInputText name="logisticsEANBox" maxlength="14"
                            [class.ng-invalid]="!productInformation.logisticsEANBoxNotAvailable && !isEanValid(productInformation.logisticsEANBox)"
                            [disabled]="productInformation.logisticsEANBoxNotAvailable"
                            [(ngModel)]="productInformation.logisticsEANBox">
                        <p-checkbox [binary]="true" [(ngModel)]="productInformation.logisticsEANBoxNotAvailable"
                            name="logisticsEANBoxNotAvailable"
                            (ngModelChange)="productInformation.logisticsEANBoxNotAvailable ? productInformation.logisticsEANBox = '' : null"></p-checkbox>
                        <label>{{app.t('rungis.notAvailable')}}</label>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label for="logistikEinheitFuellmenge"
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.logisticsAndPackaging.LogistikEinheitFuellmenge')}}</label>
                    <div class="col-12 md:col-10">
                        <p-select class="ml-2 col-2" name="logistikEinheitFuellmenge"
                            [(ngModel)]="productInformation.logistikEinheitFuellmenge"
                            [options]="[{label: app.t('rungis.logisticsAndPackaging.LogistikEinheitFuellmengeItem1'), value: 'KG'}, {label: app.t('rungis.logisticsAndPackaging.LogistikEinheitFuellmengeItem2'), value: 'L (Liter)'}]"></p-select>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.logisticsAndPackaging.logisticsNetWeight')}}</label>
                    <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                        <label class="col-1 mb-1 md:col-1 md:mb-0">{{app.t('rungis.unitPiece')}} *</label>
                        <input pInputText name="logisticsNetWeightPiece"
                            [disabled]="productInformation.logisticsNetWeightPieceNotAvailable"
                            [(ngModel)]="productInformation.logisticsNetWeightPiece"
                            [required]="!productInformation.logisticsNetWeightPieceNotAvailable && !productInformation.logisticsNetWeightBox">
                        <p-checkbox [binary]="true" name="logisticsNetWeightPieceNotAvailable"
                            [(ngModel)]="productInformation.logisticsNetWeightPieceNotAvailable"
                            [disabled]="productInformation.logisticsNetWeightBoxNotAvailable"
                            (ngModelChange)="productInformation.logisticsNetWeightPieceNotAvailable ? productInformation.logisticsNetWeightPiece = '' : null"></p-checkbox>
                        <label>{{app.t('rungis.notAvailable')}}</label>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label class="col-12 flex-row align-items-center md:col-2 md:mb-0"></label>
                    <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                        <label for="eanBox" class="col-1 mb-1 md:col-1 md:mb-0">{{app.t('rungis.unitBox')}} *</label>
                        <input pInputText name="logisticsNetWeightBox"
                            [disabled]="productInformation.logisticsNetWeightBoxNotAvailable"
                            [(ngModel)]="productInformation.logisticsNetWeightBox"
                            [required]="!productInformation.logisticsNetWeightBoxNotAvailable && !productInformation.logisticsNetWeightPiece">
                        <p-checkbox [binary]="true" [(ngModel)]="productInformation.logisticsNetWeightBoxNotAvailable"
                            name="logisticsNetWeightBoxNotAvailable"
                            [disabled]="productInformation.logisticsNetWeightPieceNotAvailable"
                            (ngModelChange)="productInformation.logisticsNetWeightBoxNotAvailable ? productInformation.logisticsNetWeightBox = '' : null"></p-checkbox>
                        <label>{{app.t('rungis.notAvailable')}}</label>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.logisticsAndPackaging.logisticsGrossWeight')}}</label>
                    <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                        <label class="col-1 mb-1 md:col-1 md:mb-0">{{app.t('rungis.unitPiece')}} *</label>
                        <input pInputText [disabled]="productInformation.logisticsGrossWeightPieceNotAvailable"
                            name="logisticsGrossWeightPiece" [(ngModel)]="productInformation.logisticsGrossWeightPiece"
                            [required]="!productInformation.logisticsGrossWeightPieceNotAvailable && !productInformation.logisticsGrossWeightBox">
                        <p-checkbox [binary]="true"
                            [(ngModel)]="productInformation.logisticsGrossWeightPieceNotAvailable"
                            name="logisticsGrossWeightPieceNotAvailable"
                            [disabled]="productInformation.logisticsGrossWeightBoxNotAvailable"
                            (ngModelChange)="productInformation.logisticsGrossWeightPieceNotAvailable ? productInformation.logisticsGrossWeightPiece = '' : null"></p-checkbox>
                        <label>{{app.t('rungis.notAvailable')}}</label>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label class="col-12 flex-row align-items-center md:col-2 md:mb-0"></label>
                    <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                        <label for="eanBox" class="col-1 mb-1 md:col-1 md:mb-0">{{app.t('rungis.unitBox')}} *</label>
                        <input pInputText [disabled]="productInformation.logisticsGrossWeightBoxNotAvailable"
                            name="logisticsGrossWeightBox" [(ngModel)]="productInformation.logisticsGrossWeightBox"
                            [required]="!productInformation.logisticsGrossWeightBoxNotAvailable && !productInformation.logisticsGrossWeightPiece">
                        <p-checkbox [binary]="true" [(ngModel)]="productInformation.logisticsGrossWeightBoxNotAvailable"
                            name="logisticsGrossWeightBoxNotAvailable"
                            [disabled]="productInformation.logisticsGrossWeightPieceNotAvailable"
                            (ngModelChange)="productInformation.logisticsGrossWeightBoxNotAvailable ? productInformation.logisticsGrossWeightBox = '' : null"></p-checkbox>
                        <label>{{app.t('rungis.notAvailable')}}</label>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.logisticsAndPackaging.logisticsDimensions')}}</label>
                    <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                        <label class="col-1 mb-1 md:col-1 md:mb-0">{{app.t('rungis.unitPiece')}} *</label>
                        <label>L</label><input type="number" class="col-1" pInputText name="logisticsDimensionsPieceL"
                            [disabled]="productInformation.logisticsDimensionsPieceNotAvailable"
                            [(ngModel)]="productInformation.logisticsDimensionsPieceL"
                            [required]="!productInformation.logisticsDimensionsPieceNotAvailable && !productInformation.logisticsDimensionsBoxL">
                        <label>B</label><input type="number" class="col-1" pInputText name="logisticsDimensionsPieceB"
                            [disabled]="productInformation.logisticsDimensionsPieceNotAvailable"
                            [(ngModel)]="productInformation.logisticsDimensionsPieceB"
                            [required]="!productInformation.logisticsDimensionsPieceNotAvailable && !productInformation.logisticsDimensionsBoxB">
                        <label>H</label><input type="number" class="col-1" pInputText name="logisticsDimensionsPieceH"
                            [disabled]="productInformation.logisticsDimensionsPieceNotAvailable"
                            [(ngModel)]="productInformation.logisticsDimensionsPieceH"
                            [required]="!productInformation.logisticsDimensionsPieceNotAvailable && !productInformation.logisticsDimensionsBoxH">
                        <p-checkbox name="logisticsDimensionsPieceNotAvailable" [binary]="true"
                            [(ngModel)]="productInformation.logisticsDimensionsPieceNotAvailable"
                            (ngModelChange)="pieceDimensionChecked()"
                            [disabled]="productInformation.logisticsDimensionsBoxNotAvailable"></p-checkbox>
                        <label for="dimensionsPieceNA">{{app.t('rungis.notAvailable')}}</label>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label class="col-12 flex-row align-items-center md:col-2 md:mb-0"></label>
                    <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                        <label class="col-1 mb-1 md:col-1 md:mb-0">{{app.t('rungis.unitBox')}} *</label>
                        <label>L</label><input type="number" class="col-1" pInputText name="logisticsDimensionsBoxL"
                            [disabled]="productInformation.logisticsDimensionsBoxNotAvailable"
                            [(ngModel)]="productInformation.logisticsDimensionsBoxL"
                            [required]="!productInformation.logisticsDimensionsBoxNotAvailable && !productInformation.logisticsDimensionsPieceL">
                        <label>B</label><input type="number" class="col-1" pInputText name="logisticsDimensionsBoxB"
                            [disabled]="productInformation.logisticsDimensionsBoxNotAvailable"
                            [(ngModel)]="productInformation.logisticsDimensionsBoxB"
                            [required]="!productInformation.logisticsDimensionsBoxNotAvailable && !productInformation.logisticsDimensionsPieceB">
                        <label>H</label><input type="number" class="col-1" pInputText name="logisticsDimensionsBoxH"
                            [disabled]="productInformation.logisticsDimensionsBoxNotAvailable"
                            [(ngModel)]="productInformation.logisticsDimensionsBoxH"
                            [required]="!productInformation.logisticsDimensionsBoxNotAvailable && !productInformation.logisticsDimensionsPieceH">
                        <p-checkbox name="logisticsDimensionsBoxNotAvailable" [binary]="true"
                            [(ngModel)]="productInformation.logisticsDimensionsBoxNotAvailable"
                            (ngModelChange)="boxDimensionChecked()"
                            [disabled]="productInformation.logisticsDimensionsPieceNotAvailable"></p-checkbox>
                        <label for="dimensionsBoxNA">{{app.t('rungis.notAvailable')}}</label>
                    </div>
                </div>
                <p-fieldset [legend]="app.t('rungis.logisticsAndPackaging.set2')">
                    <div class="flex-row mb-3 grid">
                        <label for="weightGlas"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.logisticsAndPackaging.packagingGlassWeight')}}
                            *</label>
                        <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                            <input pInputText class="col-1" name="packagingGlassWeight" type="number"
                                [disabled]="productInformation.packagingGlassWeightNotAvailable"
                                [(ngModel)]="productInformation.packagingGlassWeight"
                                [required]="!productInformation.packagingGlassWeightNotAvailable">
                            <p-checkbox name="packagingGlassWeightNotAvailable" [binary]="true"
                                [(ngModel)]="productInformation.packagingGlassWeightNotAvailable"
                                (ngModelChange)="productInformation.packagingGlassWeightNotAvailable ? productInformation.packagingGlassWeight = '' : null"></p-checkbox>
                            <label for="weightGlasNA">{{app.t('rungis.notAvailable')}}</label>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="weightPaper"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.logisticsAndPackaging.packagingPaperWeight')}}
                            *</label>
                        <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                            <input pInputText class="col-1" name="packagingPaperWeight" type="number"
                                [disabled]="productInformation.packagingPaperWeightNotAvailable"
                                [(ngModel)]="productInformation.packagingPaperWeight"
                                [required]="!productInformation.packagingPaperWeightNotAvailable">
                            <p-checkbox name="packagingPaperWeightNotAvailable" [binary]="true"
                                [(ngModel)]="productInformation.packagingPaperWeightNotAvailable"
                                (ngModelChange)="productInformation.packagingPaperWeightNotAvailable ? productInformation.packagingPaperWeight = '' : null"></p-checkbox>
                            <label for="weightPaperNA">{{app.t('rungis.notAvailable')}}</label>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="weightTinplate"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.logisticsAndPackaging.packagingTinplateWeight')}}
                            *</label>
                        <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                            <input pInputText class="col-1" name="packagingTinplateWeight" type="number"
                                [disabled]="productInformation.packagingTinplateWeightNotAvailable"
                                [(ngModel)]="productInformation.packagingTinplateWeight"
                                [required]="!productInformation.packagingTinplateWeightNotAvailable">
                            <p-checkbox name="packagingTinplateWeightNotAvailable" [binary]="true"
                                [(ngModel)]="productInformation.packagingTinplateWeightNotAvailable"
                                (ngModelChange)="productInformation.packagingTinplateWeightNotAvailable ? productInformation.packagingTinplateWeight = '' : null"></p-checkbox>
                            <label for="weightTinplateNA">{{app.t('rungis.notAvailable')}}</label>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="weightAluminum"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.logisticsAndPackaging.packagingAluminumWeight')}}
                            *</label>
                        <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                            <input pInputText class="col-1" name="packagingAluminumWeight" type="number"
                                [disabled]="productInformation.packagingAluminumWeightNotAvailable"
                                [(ngModel)]="productInformation.packagingAluminumWeight"
                                [required]="!productInformation.packagingAluminumWeightNotAvailable">
                            <p-checkbox name="packagingAluminumWeightNotAvailable" [binary]="true"
                                [(ngModel)]="productInformation.packagingAluminumWeightNotAvailable"
                                (ngModelChange)="productInformation.packagingAluminumWeightNotAvailable ? productInformation.packagingAluminumWeight = '' : null"></p-checkbox>
                            <label for="weightAluminumNA">{{app.t('rungis.notAvailable')}}</label>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="weightPlastic"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.logisticsAndPackaging.packagingPlasticWeight')}}
                            *</label>
                        <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                            <input pInputText class="col-1" name="packagingPlasticWeight" type="number"
                                [disabled]="productInformation.packagingPlasticWeightNotAvailable"
                                [(ngModel)]="productInformation.packagingPlasticWeight"
                                [required]="!productInformation.packagingPlasticWeightNotAvailable">
                            <p-checkbox name="packagingPlasticWeightNotAvailable" [binary]="true"
                                [(ngModel)]="productInformation.packagingPlasticWeightNotAvailable"
                                (ngModelChange)="productInformation.packagingPlasticWeightNotAvailable ? productInformation.packagingPlasticWeight = '' : null"></p-checkbox>
                            <label for="weightPlasticNA">{{app.t('rungis.notAvailable')}}</label>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="weightComposite"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.logisticsAndPackaging.packagingCompositeWeight')}}
                            *</label>
                        <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                            <input pInputText class="col-1" name="packagingCompositeWeight" type="number"
                                [disabled]="productInformation.packagingCompositeWeightNotAvailable"
                                [(ngModel)]="productInformation.packagingCompositeWeight"
                                [required]="!productInformation.packagingCompositeWeightNotAvailable">
                            <p-checkbox name="packagingCompositeWeightNotAvailable" [binary]="true"
                                [(ngModel)]="productInformation.packagingCompositeWeightNotAvailable"
                                (ngModelChange)="productInformation.packagingCompositeWeightNotAvailable ? productInformation.packagingCompositeWeight = '' : null"></p-checkbox>
                            <label for="weightCompositeNA">{{app.t('rungis.notAvailable')}}</label>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="weightNatural"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.logisticsAndPackaging.packagingNaturalWeight')}}
                            *</label>
                        <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                            <input pInputText class="col-1" name="packagingNaturalWeight" type="number"
                                [disabled]="productInformation.packagingNaturalWeightNotAvailable"
                                [(ngModel)]="productInformation.packagingNaturalWeight"
                                [required]="!productInformation.packagingNaturalWeightNotAvailable">
                            <p-checkbox name="packagingNaturalWeightNotAvailable" [binary]="true"
                                [(ngModel)]="productInformation.packagingNaturalWeightNotAvailable"
                                (ngModelChange)="productInformation.packagingNaturalWeightNotAvailable ? productInformation.packagingNaturalWeight = '' : null"></p-checkbox>
                            <label for="weightNaturalNA">{{app.t('rungis.notAvailable')}}</label>
                        </div>
                    </div>
                </p-fieldset>
                <p-fieldset [legend]="app.t('rungis.logisticsAndPackaging.set3')">
                    <div class="flex-row mb-3 grid">
                        <label for="piecesPerBox"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.logisticsAndPackaging.packagingPiecesPerBox')}}
                            *</label>
                        <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                            <input pInputText class="col-1" name="packagingPiecesPerBox" type="number"
                                [(ngModel)]="productInformation.packagingPiecesPerBox"
                                (ngModelChange)="calculateTotal()" required>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="boxesPerLayer"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.logisticsAndPackaging.packagingPiecesPerLayer')}}
                            *</label>
                        <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                            <input pInputText class="col-1" name="packagingBoxesPerLayer" type="number"
                                [(ngModel)]="productInformation.packagingBoxesPerLayer"
                                (ngModelChange)="calculateTotal()" required>
                            <label>{{app.t('rungis.logisticsAndPackaging.perLayer')}}: {{
                                productInformation.packagingPiecesPerBox *
                                productInformation.packagingBoxesPerLayer }}</label>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="layersPerPalette"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.logisticsAndPackaging.packagingLayersPerPalette')}}
                            *</label>
                        <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                            <input pInputText class="col-1" name="packagingLayersPerPalette" type="number"
                                [(ngModel)]="productInformation.packagingLayersPerPalette"
                                (ngModelChange)="calculateTotal()" required>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.logisticsAndPackaging.packagingTotalPerPalette')}}</label>
                        <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                            <label>{{ this.productInformation.packagingTotalPerPalette }}</label>
                        </div>
                    </div>
                </p-fieldset>
            </p-fieldset>
            <div class="flex-row align-items-center flex-wrap gap-3 mt-3">
                <div class=" flex-col mb-3">
                    <p-button name="backTab5" [label]="app.t('general.back')"
                        (onClick)="previousTab()"></p-button>
                </div>
                <div class=" flex-col mb-3">
                    <p-button name="forwardTab5" [label]="app.t('general.continue')"
                        (onClick)="nextTab()"></p-button>
                </div>
                <div class=" flex-col mb-3">
                    <p-button name="saveTab5" [label]="app.t('rungis.save')" (click)="save()"></p-button>
                </div>
            </div>
        </sm-tab>
        <sm-tab [header]="app.t('rungis.allergens.title')">
            <p-fieldset [legend]="app.t('rungis.allergens.set1')" class="fluid">
                <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                    <p-checkbox name="allergenesNotAvailable" [binary]="true"
                        [(ngModel)]="productInformation.allergenesNotAvailable"
                        (ngModelChange)="disableAllergens()"></p-checkbox>
                    <label>{{app.t('rungis.notAvailable')}}</label>
                </div>
                @if (!productInformation.allergenesNotAvailable) {
                <div>
                    <div class="flex-row mb-3 grid">
                        <label class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.allergens.allergens.all')}}
                            *</label>
                        <div class="flex-row align-items-center flex-wrap gap-3">
                            <div class="flex-row align-items-center flex-wrap gap-3">
                                <div class="flex-row align-items-center gap-2 ">
                                    <p-radioButton name="allergenStatusAll" [(ngModel)]="allAllergensStatus"
                                        value="vorhanden" (ngModelChange)="changeAllAllergens('vorhanden')" />
                                    <label>{{app.t('rungis.available')}}</label>
                                </div>
                                <div class="flex-row align-items-center gap-2 ">
                                    <p-radioButton name="allergenStatusAll" [(ngModel)]="allAllergensStatus"
                                        value="Spuren enthalten"
                                        (ngModelChange)="changeAllAllergens('Spuren enthalten')" />
                                    <label>{{app.t('rungis.inTraces')}}</label>
                                </div>
                                <div class="flex-row align-items-center gap-2 ">
                                    <p-radioButton name="allergenStatusAll" [(ngModel)]="allAllergensStatus"
                                        value="nicht vorhanden"
                                        (ngModelChange)="changeAllAllergens('nicht vorhanden')" />
                                    <label>{{app.t('rungis.notAvailable')}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    @for (allergen of productInformation.allergens; track allergen; let index = $index) {
                    <div class="flex-row mb-3 grid">
                        <label class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.allergens.allergens.' +
                            escapePropertyName(allergen.name), null, allergen.name)}} *</label>
                        <div class="flex-row align-items-center flex-wrap gap-3">
                            <div class="flex-row align-items-center flex-wrap gap-3">
                                <div class="flex-row align-items-center gap-2 ">
                                    <p-radioButton name="{{'allergenStatusAvailable' + allergen.name}}"
                                        [(ngModel)]="allergen.status" value="vorhanden"
                                        [required]="!productInformation.allergenesNotAvailable" />
                                    <label>{{app.t('rungis.available')}}</label>
                                </div>
                                <div class="flex-row align-items-center gap-2 ">
                                    <p-radioButton name="{{'allergenStatusContains' + allergen.name}}"
                                        [(ngModel)]="allergen.status" value="Spuren enthalten"
                                        [required]="!productInformation.allergenesNotAvailable" />
                                    <label>{{app.t('rungis.inTraces')}}</label>
                                </div>
                                <div class="flex-row align-items-center gap-2 ">
                                    <p-radioButton name="{{'allergenNotAvailable' + allergen.name}}"
                                        [(ngModel)]="allergen.status" value="nicht vorhanden"
                                        [required]="!productInformation.allergenesNotAvailable" />
                                    <label>{{app.t('rungis.notAvailable')}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </div>
                }
            </p-fieldset>
            <div class="flex-row align-items-center flex-wrap gap-3 mt-3">
                <div class=" flex-col mb-3">
                    <p-button name="backTab6" [label]="app.t('general.back')"
                        (onClick)="previousTab()"></p-button>
                </div>
                <div class=" flex-col mb-3">
                    <p-button name="forwardTab6" [label]="app.t('general.continue')"
                        (onClick)="nextTab()"></p-button>
                </div>
                <div class=" flex-col mb-3">
                    <p-button name="saveTab6" [label]="app.t('rungis.save')" (click)="save()"></p-button>
                </div>
            </div>
        </sm-tab>
        <sm-tab [header]="app.t('rungis.nutrition.title')">
            <div class="flex-row mb-3 grid">
                <label class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.nutrition.ingredients')}} *</label>
            </div>
            <div class=" flex-col mb-3">
                <textarea rows="5" cols="75" pTextarea name="nutritionIngredients"
                    [(ngModel)]="productInformation.nutritionIngredients" required></textarea>
            </div>
            <p-fieldset [legend]="app.t('rungis.nutrition.set1')" class="fluid">
                <div class="flex-row mb-3 grid">
                    <div class="flex-row align-items-center flex-wrap gap-3">
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="nutritionNAYes" [(ngModel)]="productInformation.nutritionNA"
                                value="erforderlich" (ngModelChange)="checkNutrition()" required />
                            <label for="lmivYes">{{app.t('rungis.needed')}}</label>
                        </div>
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="nutritionNANo" [(ngModel)]="productInformation.nutritionNA"
                                value="nicht erforderlich" (ngModelChange)="checkNutrition()" required />
                            <label for="lmivNo">{{app.t('rungis.notNeeded')}}</label>
                        </div>
                    </div>
                </div>
                <!-- <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                                                                                                                                      <p-checkbox name="nutritionNA" [binary]="true"
                                                                                                                                        [(ngModel)]="productInformation.nutritionNA"
                                                                                                                                      (ngModelChange)="checkNutrition()"></p-checkbox>
                                                                                                                                      <label for="kcalNA">{{app.t('rungis.notNeeded')}}</label>
                                                                                                                                    </div> -->
                @if (productInformation.nutritionNA == 'erforderlich') {
                <div>
                    <div class="flex-row mb-3 grid">
                        <label
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.nutrition.nutritionKjKcal')}}</label>
                        <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                            <input pInputText name="nutritionKjKcal" [disabled]="productInformation.nutritionKjKcalNA"
                                [(ngModel)]="productInformation.nutritionKjKcal"
                                [required]="productInformation.nutritionNA == 'erforderlich'">
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.nutrition.nutritionFat')}}</label>
                        <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                            <input pInputText name="nutritionFat" [disabled]="productInformation.nutritionFatNA"
                                [(ngModel)]="productInformation.nutritionFat"
                                [required]="productInformation.nutritionNA == 'erforderlich'" (blur)="fatChanged()">
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.nutrition.nutritionSaturatedFat')}}</label>
                        <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                            <input pInputText name="nutritionSaturatedFat"
                                [disabled]="productInformation.nutritionSaturatedFatNA"
                                [(ngModel)]="productInformation.nutritionsaturatedFat"
                                [required]="productInformation.nutritionNA == 'erforderlich'"
                                (ngModelChange)="saturatedFatChanged()">
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.nutrition.nutritionCarbs')}}</label>
                        <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                            <input pInputText name="nutritionCarbs" [disabled]="productInformation.nutritionCarbsNA"
                                [required]="productInformation.nutritionNA == 'erforderlich'"
                                [(ngModel)]="productInformation.nutritionCarbs" (blur)="carbsChanged()">
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.nutrition.nutritionCarbsSugar')}}</label>
                        <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                            <input pInputText name="nutritionSugar" [disabled]="productInformation.nutritionCarbSugarNA"
                                [(ngModel)]="productInformation.nutritionCarbsSugar"
                                [required]="productInformation.nutritionNA == 'erforderlich'"
                                (blur)="productInformation.nutritionCarbsSugar > productInformation.nutritionCarbs ? productInformation.nutritionCarbsSugar = productInformation.nutritionCarbs : null">
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.nutrition.nutritionProtein')}}</label>
                        <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                            <input pInputText name="nutritionProtein" [disabled]="productInformation.nutritionProteinNA"
                                [required]="productInformation.nutritionNA == 'erforderlich'"
                                [(ngModel)]="productInformation.nutritionProtein" (blur)="proteinChanged()">
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.nutrition.nutritionSalt')}}</label>
                        <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                            <input pInputText name="nutritionSalt" [disabled]="productInformation.nutritionSaltNA"
                                [required]="productInformation.nutritionNA == 'erforderlich'"
                                [(ngModel)]="productInformation.nutritionSalt" (blur)="saltChanged()">
                        </div>
                    </div>
                </div>
                }
            </p-fieldset>
            <div class="flex-row align-items-center flex-wrap gap-3 mt-3">
                <div class=" flex-col mb-3">
                    <p-button name="backTab7" [label]="app.t('general.back')"
                        (onClick)="previousTab()"></p-button>
                </div>
                <div class=" flex-col mb-3">
                    <p-button name="forwardTab7" [label]="app.t('general.continue')"
                        (onClick)="nextTab()"></p-button>
                </div>
                <div class=" flex-col mb-3">
                    <p-button name="saveTab7" [label]="app.t('rungis.save')" (click)="save()"></p-button>
                </div>
            </div>
        </sm-tab>
        <sm-tab [header]="app.t('rungis.additives.title')">
            <p-fieldset [legend]="app.t('rungis.additives.set1')" class="fluid">
                <div class="flex-row mb-3 grid">
                    <label class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.additives.additivesLMIV')}}</label>
                    <div class="flex-row align-items-center flex-wrap gap-3">
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="additivesLMIV" [(ngModel)]="productInformation.additivesLMIV"
                                value="erforderlich" />
                            <label for="lmivYes">{{app.t('rungis.needed')}}</label>
                        </div>
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="additivesLMIV" [(ngModel)]="productInformation.additivesLMIV"
                                value="nicht erforderlich" />
                            <label for="lmivNo">{{app.t('rungis.notNeeded')}}</label>
                        </div>
                    </div>
                </div>
                @if (productInformation.additivesLMIV === 'erforderlich') {
                <div>
                    @for (category of uniqueCategories; track category) {
                    <div class="flex-row mb-3 grid">
                        <label class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{this.app.t('rungis.additives.categories.' +
                            category, null, category)}}</label>
                        <div class="flex-row align-items-center flex-wrap gap-3">
                            <p-multiSelect [options]="groupedAdditives[category]"
                                [(ngModel)]="selectedAdditives[category]"
                                [placeholder]="app.t('rungis.additives.selectAdditives')"
                                (ngModelChange)="onAdditiveSelectionChange(category)"
                                optionLabel="label" class="fixed-width-multiselect" name="additives{{category}}">
                            </p-multiSelect>
                        </div>
                    </div>
                    }
                </div>
                }
            </p-fieldset>
            <div class="flex-row align-items-center flex-wrap gap-3 mt-3">
                <div class=" flex-col mb-3">
                    <p-button name="backTab8" [label]="app.t('general.back')"
                        (onClick)="previousTab()"></p-button>
                </div>
                <div class=" flex-col mb-3">
                    <p-button name="forwardTab8" [label]="app.t('general.continue')"
                        (onClick)="nextTab()"></p-button>
                </div>
                <div class=" flex-col mb-3">
                    <p-button name="saveTab8" [label]="app.t('rungis.save')" (click)="save()"></p-button>
                </div>
            </div>
        </sm-tab>
        <sm-tab [header]="app.t('rungis.remarks.title')">
            <div class="flex-row mb-3 grid">
                <p-fieldset class="col-6" [legend]="app.t('rungis.remarks.set1')">
                    <div class="flex-row mb-3 grid">
                        <label class="col-12 flex-row align-items-center md:col-4 md:mb-0">{{app.t('rungis.remarks.hintsRecommendation')}}
                            *</label>
                        <div class="col-12 md:col-8 flex-row align-items-center gap-2">
                            <p-checkbox [binary]="true" name="hintsRecommendationNotAvailable"
                                [(ngModel)]="productInformation.hintsRecommendationNotAvailable"></p-checkbox>
                            <label for="grossWeightPieceNA">{{app.t('rungis.notAvailable')}}</label>
                        </div>
                    </div>
                    <div class=" flex-col mb-3">
                        <textarea rows="5" cols="75" pTextarea name="hintsRecommendation"
                            [(ngModel)]="productInformation.hintsRecommendation"
                            [required]="!productInformation.hintsRecommendationNotAvailable"></textarea>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.remarks.hintsRequiresRefrigeration')}}
                            *</label>
                        <div class="flex-row align-items-center flex-wrap gap-3">
                            <div class="flex-row align-items-center gap-2 ">
                                <p-radioButton name="hintsRequiresRefrigeration"
                                    [(ngModel)]="productInformation.hintsRequiresRefrigeration" value="ja" required />
                                <label for="coolingYes">{{app.t('general.yes')}}</label>
                            </div>
                            <div class="flex-row align-items-center gap-2 ">
                                <p-radioButton name="hintsRequiresRefrigeration"
                                    [(ngModel)]="productInformation.hintsRequiresRefrigeration" value="nein" required />
                                <label for="coolingNo">{{app.t('general.no')}}</label>
                            </div>
                        </div>
                    </div>
                    @if (productInformation.hintsRequiresRefrigeration == 'ja') {
                    <div class="flex-row mb-3 grid">
                        <label class="col-12 flex-row align-items-center md:col-2 md:mb-0"></label>
                        <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                            <label for="temperature"
                                class="col-1 mb-1 md:col-1 md:mb-0">{{app.t('rungis.remarks.hintsRefrigerationTemperature')}}</label>
                            <input pInputText name="hintsRefrigerationTemperature" maxlength="50" placeholder="In °C"
                                [(ngModel)]="productInformation.hintsRefrigerationTemperature"
                                [required]="productInformation.hintsRequiresRefrigeration == 'ja'">
                        </div>
                    </div>
                    }
                    <div class="flex-row mb-3 grid">
                        <label class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.remarks.hintsStorageInstructions')}}
                            *</label>
                    </div>
                    <div class=" flex-col mb-3">
                        <textarea rows="5" cols="75" pTextarea name="hintsStorageInstructions"
                            [(ngModel)]="productInformation.hintsStorageInstructions" required></textarea>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.remarks.hintsSpecialMarkings')}}
                            *</label>
                        <div class="flex-row align-items-center flex-wrap gap-3">
                            <div class="flex-row align-items-center gap-2 ">
                                <p-radioButton name="hintsSpecialMarkings"
                                    [(ngModel)]="productInformation.hintsSpecialMarkings" value="ja" required />
                                <label for="specialMarkingYes">{{app.t('general.yes')}}</label>
                            </div>
                            <div class="flex-row align-items-center gap-2 ">
                                <p-radioButton name="hintsSpecialMarkings"
                                    [(ngModel)]="productInformation.hintsSpecialMarkings" value="nein" required />
                                <label for="specialMarkingNo">{{app.t('general.no')}}</label>
                            </div>
                        </div>
                    </div>
                    @if (productInformation.hintsSpecialMarkings == 'ja') {
                    <div>
                        <div class="flex-row mb-3 grid">
                            <label class="col-12 flex-row align-items-center md:col-2 md:mb-0"></label>
                            <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                                <p-checkbox name="hintsMarkingGluten" [binary]="true"
                                    [(ngModel)]="productInformation.hintsMarkingGluten"></p-checkbox>
                                <label
                                    for="supplierProductNumberNA">{{app.t('rungis.remarks.hintsMarkingGluten')}}</label>
                            </div>
                        </div>
                        <div class="flex-row mb-3 grid">
                            <label class="col-12 flex-row align-items-center md:col-2 md:mb-0"></label>
                            <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                                <p-checkbox name="hintsMarkingVegetarian" [binary]="true"
                                    [(ngModel)]="productInformation.hintsMarkingVegetarian"></p-checkbox>
                                <label
                                    for="supplierProductNumberNA">{{app.t('rungis.remarks.hintsMarkingVegetarian')}}</label>
                            </div>
                        </div>
                        <div class="flex-row mb-3 grid">
                            <label class="col-12 flex-row align-items-center md:col-2 md:mb-0"></label>
                            <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                                <p-checkbox name="hintsMarkingVegan" [binary]="true"
                                    [(ngModel)]="productInformation.hintsMarkingVegan"></p-checkbox>
                                <label
                                    for="supplierProductNumberNA">{{app.t('rungis.remarks.hintsMarkingVegan')}}</label>
                            </div>
                        </div>
                        <div class="flex-row mb-3 grid">
                            <label class="col-12 flex-row align-items-center md:col-2 md:mb-0"></label>
                            <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                                <p-checkbox name="hintsMarkingLaktoseFree" [binary]="true"
                                    [(ngModel)]="productInformation.hintsMarkingLaktoseFree"></p-checkbox>
                                <label
                                    for="supplierProductNumberNA">{{app.t('rungis.remarks.hintsMarkingLaktoseFree')}}</label>
                            </div>
                        </div>
                        <div class="flex-row mb-3 grid">
                            <label class="col-12 flex-row align-items-center md:col-2 md:mb-0"></label>
                            <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                                <p-checkbox name="hintsMarkingAlcohol" [binary]="true"
                                    [(ngModel)]="productInformation.hintsMarkingAlcohol"></p-checkbox>
                                <label
                                    for="supplierProductNumberNA">{{app.t('rungis.remarks.hintsMarkingAlcohol')}}</label>
                            </div>
                        </div>
                        @if (productInformation.hintsMarkingAlcohol) {
                        <div class="flex-row mb-3 grid">
                            <label class="col-12 flex-row align-items-center md:col-2 md:mb-0"></label>
                            <div class="col-12 md:col-10 flex-row align-items-center gap-2">
                                <label for="alcoholVol"
                                    class="col-1 mb-1 md:col-1 md:mb-0">{{app.t('rungis.remarks.hintsMarkingAlcoholAmount')}}</label>
                                <input pInputText name="hintsMarkingAlcoholAmount" class="col-1"
                                    [required]="productInformation.hintsMarkingAlcohol"
                                    [(ngModel)]="productInformation.hintsMarkingAlcoholAmount">
                            </div>
                        </div>
                        }
                    </div>
                    }
                </p-fieldset>
                <p-fieldset class="mt-2 col-6" [legend]="app.t('rungis.remarks.set3')">
                    <div class="flex-row mb-3 grid">
                        <label for="hinweisAuftauzeit"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.remarks.hinweisAuftauzeit')}}</label>
                        <div class="col-12 md:col-10">
                            <input pInputText name="hinweisAuftauzeit" maxlength="10"
                                [(ngModel)]="productInformation.hinweisAuftauzeit" />
                            <span class="ml-2">{{app.t('rungis.remarks.hinweisUnitHours')}}</span>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="hinweisAuftautemperatur"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.remarks.hinweisAuftautemperatur')}}</label>
                        <div class="col-12 md:col-10">
                            <input pInputText name="hinweisAuftautemperatur" maxlength="3"
                                [(ngModel)]="productInformation.hinweisAuftautemperatur" />
                            <span class="ml-2">{{app.t('rungis.remarks.hinweisUnitTemperature')}}</span>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="hinweisBackzeit"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.remarks.hinweisBackzeit')}}</label>
                        <div class="col-12 md:col-10">
                            <input pInputText name="hinweisBackzeit" maxlength="10"
                                [(ngModel)]="productInformation.hinweisBackzeit" />
                            <span class="ml-2">{{app.t('rungis.remarks.hinweisUnitMinutes')}}</span>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="hinweisBacktemperatur"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.remarks.hinweisBacktemperatur')}}</label>
                        <div class="col-12 md:col-10">
                            <input pInputText name="hinweisBacktemperatur" maxlength="3"
                                [(ngModel)]="productInformation.hinweisBacktemperatur" />
                            <span class="ml-2">{{app.t('rungis.remarks.hinweisUnitTemperature')}}</span>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="hinweisFrittierzeit"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.remarks.hinweisFrittierZeit')}}</label>
                        <div class="col-12 md:col-10">
                            <input pInputText name="hinweisFrittierzeit" maxlength="10"
                                [(ngModel)]="productInformation.hinweisFrittierZeit" />
                            <span class="ml-2">{{app.t('rungis.remarks.hinweisUnitMinutes')}}</span>
                        </div>
                    </div>
                    <div class="flex-row mb-3 grid">
                        <label for="hinweisFrittierTemperatur"
                            class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.remarks.hinweisFrittierTemperatur')}}</label>
                        <div class="col-12 md:col-10">
                            <input pInputText name="hinweisFrittiertemperatur" maxlength="3"
                                [(ngModel)]="productInformation.hinweisFrittierTemperatur" />
                            <span class="ml-2">{{app.t('rungis.remarks.hinweisUnitTemperature')}}</span>
                        </div>
                    </div>
                </p-fieldset>
            </div>
            <p-fieldset [legend]="app.t('rungis.remarks.set2')">
                <div class="flex-row mb-3 grid">
                    <label class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.remarks.hintsGeneticallyModified')}}
                        *</label>
                    <div class="flex-row align-items-center flex-wrap gap-3">
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="hintsGeneticallyModified"
                                [(ngModel)]="productInformation.hintsGeneticallyModified" value="ja" required />
                            <label for="geneticYes">{{app.t('general.yes')}}</label>
                        </div>
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="hintsGeneticallyModified"
                                [(ngModel)]="productInformation.hintsGeneticallyModified" value="nein" required />
                            <label for="geneticNo">{{app.t('general.no')}}</label>
                        </div>
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="hintsGeneticallyModified"
                                [(ngModel)]="productInformation.hintsGeneticallyModified" value="Nicht vorhanden"
                                required />
                            <label for="geneticNA">{{app.t('rungis.notAvailable')}}</label>
                        </div>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.remarks.hintsObtainedGeneticallyModifiedOrganisms')}}
                        *</label>
                    <div class="flex-row align-items-center flex-wrap gap-3">
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="hintsObtainedGeneticallyModifiedOrganisms"
                                [(ngModel)]="productInformation.hintsObtainedGeneticallyModifiedOrganisms" value="ja"
                                required />
                            <label for="geneticOrganismYes">{{app.t('general.yes')}}</label>
                        </div>
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="hintsObtainedGeneticallyModifiedOrganisms"
                                [(ngModel)]="productInformation.hintsObtainedGeneticallyModifiedOrganisms" value="nein"
                                required />
                            <label for="geneticOrganismNo">{{app.t('general.no')}}</label>
                        </div>
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="hintsObtainedGeneticallyModifiedOrganisms"
                                [(ngModel)]="productInformation.hintsObtainedGeneticallyModifiedOrganisms"
                                value="Nicht vorhanden" required />
                            <label for="geneticOrganismNA">{{app.t('rungis.notAvailable')}}</label>
                        </div>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.remarks.hintsProducedGeneticallyModifiedOrganisms')}}
                        *</label>
                    <div class="flex-row align-items-center flex-wrap gap-3">
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="hintsProducedGeneticallyModifiedOrganisms"
                                [(ngModel)]="productInformation.hintsProducedGeneticallyModifiedOrganisms" value="ja"
                                required />
                            <label for="geneticChangedOrganismYes">{{app.t('general.yes')}}</label>
                        </div>
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="hintsProducedGeneticallyModifiedOrganisms"
                                [(ngModel)]="productInformation.hintsProducedGeneticallyModifiedOrganisms" value="nein"
                                required />
                            <label for="geneticChangedOrganismNo">{{app.t('general.no')}}</label>
                        </div>
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="hintsProducedGeneticallyModifiedOrganisms"
                                [(ngModel)]="productInformation.hintsProducedGeneticallyModifiedOrganisms"
                                value="Nicht vorhanden" required />
                            <label for="geneticChangedOrganismNA">{{app.t('rungis.notAvailable')}}</label>
                        </div>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.remarks.hintsIonizingRadiation')}}
                        *</label>
                    <div class="flex-row align-items-center flex-wrap gap-3">
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="hintsIonizingRadiation"
                                [(ngModel)]="productInformation.hintsIonizingRadiation" value="ja" required />
                            <label for="ionizedYes">{{app.t('general.yes')}}</label>
                        </div>
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="hintsIonizingRadiation"
                                [(ngModel)]="productInformation.hintsIonizingRadiation" value="nein" required />
                            <label for="ionizedNo">{{app.t('general.no')}}</label>
                        </div>
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="hintsIonizingRadiation"
                                [(ngModel)]="productInformation.hintsIonizingRadiation" value="Nicht vorhanden"
                                required />
                            <label for="ionizedNA">{{app.t('rungis.notAvailable')}}</label>
                        </div>
                    </div>
                </div>
                <div class="flex-row mb-3 grid">
                    <label
                        class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.remarks.hintsIonizingRadiationIngredients')}}
                        *</label>
                    <div class="flex-row align-items-center flex-wrap gap-3">
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="hintsIonizingRadiationIngredients"
                                [(ngModel)]="productInformation.hintsIonizingRadiationIngredients" value="ja"
                                required />
                            <label for="ionizedProductYes">{{app.t('general.yes')}}</label>
                        </div>
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="hintsIonizingRadiationIngredients"
                                [(ngModel)]="productInformation.hintsIonizingRadiationIngredients" value="nein"
                                required />
                            <label for="ionizedProductNo">{{app.t('general.no')}}</label>
                        </div>
                        <div class="flex-row align-items-center gap-2 ">
                            <p-radioButton name="hintsIonizingRadiationIngredients"
                                [(ngModel)]="productInformation.hintsIonizingRadiationIngredients"
                                value="Nicht vorhanden" required />
                            <label for="ionizedProductNA">{{app.t('rungis.notAvailable')}}</label>
                        </div>
                    </div>
                </div>
                <div class="flex-row mb-3 grid col-12 md:col-10 flex-row align-items-center gap-2">
                    <p-checkbox [binary]="true" name="hintsConfirmed" [(ngModel)]="productInformation.hintsConfirmed"
                        [required]="true"></p-checkbox>
                    <label>{{app.t('rungis.remarks.hintsConfirmed')}} *</label>
                </div>
            </p-fieldset>
            <div class="flex-row align-items-center flex-wrap gap-3 mt-3">
                <div class=" flex-col mb-3">
                    <p-button name="backTab9" [label]="app.t('general.back')"
                        (onClick)="previousTab()"></p-button>
                </div>
                <div class=" flex-col mb-3">
                    <p-button name="forwardTab9" [label]="app.t('general.continue')"
                        (onClick)="nextTab()"></p-button>
                </div>
                <div class=" flex-col mb-3">
                    <p-button name="saveTab9" [label]="app.t('rungis.save')" (click)="save()"></p-button>
                </div>
            </div>
        </sm-tab>
        <sm-tab [header]="app.t('rungis.confirmation.title')">
            <div class="flex-row mb-3 grid">
                <label for="name" class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.confirmation.date')}} *</label>
                <div class="col-12 md:col-10">
                    <p-datepicker name="confirmationDate"
                        [ngModel]="_Dates.formatDefaultDate(productInformation.confirmationDate)" dateFormat="dd.mm.yy"
                        [required]="true" [disabled]=true></p-datepicker>
                </div>
            </div>
            <div class="flex-row mb-3 grid">
                <label for="employeeName" class="col-12 flex-row align-items-center md:col-2 md:mb-0">{{app.t('rungis.confirmation.yourName')}}
                    *</label>
                <div class="col-12 md:col-10">
                    <input pInputText name="confirmationName" [(ngModel)]="productInformation.confirmationName"
                        required>
                </div>
            </div>
            <div class="flex-row mb-3 grid col-12 md:col-12 flex-row align-items-center gap-2">
                <p-checkbox [binary]="true" name="confirmation"
                    [ngClass]="{'ng-invalid': !productInformation.confirmation}"
                    [(ngModel)]="productInformation.confirmation" [required]="true"></p-checkbox>
                <label for="confirmation">{{app.t('rungis.confirmation.confirmation')}} *</label>
            </div>
            <div class="flex-row align-items-center flex-wrap gap-3">
                <div class=" flex-col mb-3">
                    <p-button name="backTab10" [label]="app.t('general.back')"
                        (onClick)="previousTab()"></p-button>
                </div>
                <div class=" flex-col mb-3">
                    <p-button name="saveTab10" [label]="app.t('rungis.save')" (click)="save()"></p-button>
                </div>
                <div class=" flex-col mb-3">
                    <p-button name="sendForm" type="submit" [label]="app.t('rungis.send')" (click)="submitForm()"
                        [disabled]="!productInformation.confirmation"></p-button>
                </div>
            </div>
            @if (supplierForm.invalid || !customsNumberValid) {
            <div class=" flex-col mb-3">
                <label class="ng-invalid">{{app.t('rungis.errors')}}</label>
            </div>
            }
        </sm-tab>
    </sm-tab-view>
</form>
}